export const validateForm = (data) => {

    if (data == null) return false;

    const list = Object.values(data);
    let flag = true;

    list.forEach( (value, i) => {
        if(value === null || value === undefined || value === "") {
            flag = false;
        }
    });

    return flag;
}